module.exports = __webpack_public_path__ + "static/media/data-source_sales-information-resource.2151f4bf.svg";